module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_8017.3f9e9758.png";